import { z } from 'zod'

/**
 * POST /api/contact request body schema.
 */
export const ContactRequestSchema = z.object({
  // Il nome compare nelle email: lunghezza limitata, niente a capo o caratteri di controllo.
  name: z.string().trim().min(1, 'name is required').max(100).regex(/^\P{Cc}*$/u, 'name must be a single line'),
  email: z.string().trim().email('email must be valid').max(254),
  message: z.string().trim().min(1, 'message is required').max(5000),
  /** Lingua della conferma via email. */
  lang: z.enum(['it', 'en']).default('it'),
})

export type ContactRequest = z.infer<typeof ContactRequestSchema>

/**
 * POST /api/contact response body schema.
 */
export const ContactResponseSchema = z.object({
  success: z.boolean(),
  timestamp: z.string(),
})

export type ContactResponse = z.infer<typeof ContactResponseSchema>
